import { showToast } from "../../../utils/styles/toastUtils";
import { postSendOtpApi } from "../../apis/auth/postSendOtpApi";

import * as types from "../ActionTypes";

export const SendOtpStart = () => ({
  type: types.SEND_OTP_START,
});

export const SendOtpSuccess = (data) => ({
  type: types.SEND_OTP_SUCCESS,
  payload: data,
});

export const SendOtpError = (error) => ({
  type: types.SEND_OTP_ERROR,
  payload: error,
});

export const SendOtpActionInitiate = (payload) => {
  return async function (dispatch) {
    dispatch(SendOtpStart());

    // Normalize payload to object if a string or number was passed
    const requestData = typeof payload === "object" && payload !== null
      ? payload
      : { phone_number: String(payload) };

    try {
      const res = await postSendOtpApi(requestData);

      dispatch(SendOtpSuccess(res.data));

      if (res.data?.message) {
        showToast.success(res.data.message);
      }

      return {
        success: true,
        resends_remaining: res.data?.resends_remaining ?? null,
      };

    } catch (error) {
      const errorData = error.response?.data;
      const errorMessage = errorData?.error || errorData?.message;
      if (errorMessage) {
        showToast.error(errorMessage);
      }
      console.error("SendOtpError", error);
      dispatch(SendOtpError(error.message));

      if (errorData?.resend_limit_reached) {
        return { success: false, rateLimitExceeded: true };
      }
      return { success: false, error };
    }
  };
};
